export default function calcDistance(startX: number, startY: number, endX: number, endY: number): number {
	return Math.sqrt(
		Math.pow(startX - endX, 2) +
		Math.pow(startY - endY, 2)
	);
}